import { Box, Typography } from "@mui/material";
import {
  characterCountHintCaptionSx,
  characterCountNumberSx,
  characterCountRowSx,
} from "./styles";

export const LIMIT_REACHED_HELPER = "Character limit reached.";

export function CharacterCountHelperRow({
  max,
  length,
  locationHint,
}: {
  max: number;
  length: number;
  locationHint: string;
}) {
  const remaining = max - length;
  const atLimit = remaining === 0;
  return (
    <Box sx={characterCountRowSx}>
      <Typography
        component="span"
        variant="caption"
        color={atLimit ? "error" : "text.secondary"}
        sx={characterCountHintCaptionSx}
      >
        {atLimit ? LIMIT_REACHED_HELPER : locationHint}
      </Typography>
      <Typography
        component="span"
        variant="caption"
        color={atLimit ? "error" : "text.secondary"}
        sx={characterCountNumberSx}
      >
        {remaining}
      </Typography>
    </Box>
  );
}
